import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { forwardRef, useContext } from "react";
import * as Popover from "@radix-ui/react-popover";
import { Slot } from "@radix-ui/react-slot";
import { Font } from "../../Font/index.js";
import { IconWrapper } from "../../IconWrapper/index.js";
import { SideNavigationContext } from "../helpers.js";
import { Switch } from "../../Switch/index.js";
import { Tooltip } from "../../Tooltip/index.js";
import { withThemeAndSize } from "../../withThemeAndSize/index.js";
import { cn as clsx } from "../../../helpers/react.js";
import '../../../assets/index61.css';const item = "_item_xlo9j_1";
const icon = "_icon_xlo9j_17";
const active = "_active_xlo9j_27";
const textContainer = "_textContainer_xlo9j_34";
const description = "_description_xlo9j_35";
const disabled = "_disabled_xlo9j_40";
const leftIcon = "_leftIcon_xlo9j_45";
const rightIcon = "_rightIcon_xlo9j_46";
const alternate = "_alternate_xlo9j_74";
const animate = "_animate_xlo9j_111";
const withAvatar = "_withAvatar_xlo9j_126";
const leftIconContainer = "_leftIconContainer_xlo9j_130";
const rightIconContainer = "_rightIconContainer_xlo9j_136";
const text = "_text_xlo9j_34";
const switchContainer = "_switchContainer_xlo9j_181";
const badgeContainer = "_badgeContainer_xlo9j_188";
const collapsed = "_collapsed_xlo9j_193";
const badge = "_badge_xlo9j_188";
const avatar = "_avatar_xlo9j_219";
const s = {
  item,
  icon,
  active,
  textContainer,
  description,
  disabled,
  leftIcon,
  rightIcon,
  alternate,
  animate,
  "alternate-border-animation": "_alternate-border-animation_xlo9j_1",
  withAvatar,
  leftIconContainer,
  rightIconContainer,
  text,
  switchContainer,
  badgeContainer,
  collapsed,
  badge,
  avatar
};
const SideNavigationItem = withThemeAndSize(
  forwardRef((props, ref) => {
    const {
      text: text2,
      description: description2,
      leftIcon: leftIcon2,
      showSwitch,
      disabled: disabled2,
      alternate: alternate2,
      animate: animate2,
      rightIcon: rightIcon2,
      badge: badge2,
      avatar: avatar2,
      tooltipText,
      active: active2,
      popupContent,
      popupContentProps,
      ...rest
    } = props;
    const { isExpanded } = useContext(SideNavigationContext);
    const content = /* @__PURE__ */ jsxs(
      "a",
      {
        ref,
        ...rest,
        "aria-disabled": disabled2,
        className: clsx(s.item, {
          [s.active]: active2,
          [s.collapsed]: !isExpanded,
          [s.disabled]: disabled2,
          [s.alternate]: alternate2,
          [s.animate]: animate2,
          [s.withAvatar]: Boolean(avatar2)
        }),
        children: [
          /* @__PURE__ */ jsxs("div", { className: s.leftIconContainer, children: [
            leftIcon2 && /* @__PURE__ */ jsx(IconWrapper, { size: "md", className: s.icon, children: leftIcon2 }),
            avatar2 && /* @__PURE__ */ jsx(Slot, { className: s.avatar, children: avatar2 })
          ] }),
          /* @__PURE__ */ jsxs("div", { className: s.textContainer, children: [
            /* @__PURE__ */ jsx(Font, { type: "text", size: 14, weight: "regular", children: /* @__PURE__ */ jsx("span", { className: s.text, children: text2 }) }),
            /* @__PURE__ */ jsx(Font, { type: "text", size: 10, weight: "regular", children: /* @__PURE__ */ jsx("span", { className: s.description, children: description2 }) })
          ] }),
          showSwitch && /* @__PURE__ */ jsx("div", { className: s.switchContainer, children: /* @__PURE__ */ jsx(Switch, { disabled: disabled2, size: "compact", switchState: active2 }) }),
          badge2 && /* @__PURE__ */ jsx("div", { className: s.badgeContainer, children: /* @__PURE__ */ jsx(Slot, { className: s.badge, children: badge2 }) }),
          rightIcon2 && /* @__PURE__ */ jsx("div", { className: s.rightIconContainer, children: /* @__PURE__ */ jsx(IconWrapper, { size: "md", className: s.icon, children: rightIcon2 }) })
        ]
      }
    );
    if (!tooltipText && !popupContent) {
      return content;
    }
    if (tooltipText && !popupContent) {
      return /* @__PURE__ */ jsx(Tooltip, { content: tooltipText, side: "right", children: content });
    }
    if (!tooltipText && popupContent) {
      return /* @__PURE__ */ jsxs(Popover.Root, { children: [
        /* @__PURE__ */ jsx(Popover.Trigger, { asChild: true, children: content }),
        /* @__PURE__ */ jsx(Popover.Portal, { children: /* @__PURE__ */ jsx(Popover.Content, { side: "right", align: "start", style: { zIndex: 999999 }, ...popupContentProps, children: popupContent }) })
      ] });
    }
    return /* @__PURE__ */ jsx(Tooltip, { content: tooltipText, side: "right", children: /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(Popover.Root, { children: [
      /* @__PURE__ */ jsx(Tooltip.Trigger, { children: /* @__PURE__ */ jsx(Popover.Trigger, { asChild: true, children: content }) }),
      /* @__PURE__ */ jsx(Popover.Portal, { children: /* @__PURE__ */ jsx(Popover.Content, { side: "right", align: "start", style: { zIndex: 999999 }, ...popupContentProps, children: popupContent }) })
    ] }) }) });
  })
);
export {
  SideNavigationItem
};
